// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const videoPlayButtons = document.querySelectorAll('.js-video-play');

    /**
     * On play button click, inject the YouTube iframe into its modal
     */

    for (const videoPlayButton of videoPlayButtons) {

        videoPlayButton.addEventListener('click', () => {

            const videoId = videoPlayButton.dataset.videoId;
            const videoModalId = videoPlayButton.dataset.modal;
            const videoModal = document.querySelector(`.modal--video[data-modal="${videoModalId}"]`);
            const videoModalContent = videoModal ? videoModal.querySelector('.js-video-modal-content') : null;

            if (!videoId || !videoModalContent) {
                return;
            }

            const videoIframe = document.createElement('iframe');
            videoIframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`);
            videoIframe.setAttribute('title', 'YouTube video player');
            videoIframe.setAttribute('frameborder', '0');
            videoIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            videoIframe.setAttribute('allowfullscreen', '');

            videoModalContent.innerHTML = '';
            videoModalContent.appendChild(videoIframe);

        });

    }

    /**
     * On modal close (icon, overlay click or Escape key), remove the iframe so the video stops playing
     */

    document.addEventListener('modal:closed', (e) => {

        const videoModal = document.querySelector(`.modal--video[data-modal="${e.detail.modalId}"]`);
        const videoModalContent = videoModal ? videoModal.querySelector('.js-video-modal-content') : null;

        if (videoModalContent) {
            videoModalContent.innerHTML = '';
        }

    });

});
